export default getText => key =>
  ({
    result: getText('result', 'Layout_Search_List'),
    results: getText('results', 'Layout_Search_List'),
  }[key])
